module.exports = __webpack_public_path__ + "assets/img/rolling-button.afbebe11.svg";